export default __webpack_public_path__ + "static/Forms_Default-ad8e4a87484327c4dc1db0f516f6a1f0.png";